<div class="content">
  @if (template().symbol; as symbol) {
    <rt-symbol [symbol]="symbol" margin-right-small-x />
  }
  <div layout-vertical>
    <rt-heading variant="heading">
      <span class="template-name">{{ template().name }}</span>
    </rt-heading>
    <div
      prosemirrorBasicConfig
      [prosemirrorRender]="
        !template().descriptionJson || template().descriptionJson.doc
          ? template().descriptionJson
          : { doc: template().descriptionJson }
      "
      [prosemirrorRenderConfig]="ProsemirrorBasicConfig"
      class="description-content"
    ></div>
  </div>
  <rt-admins-avatars [admins]="assignedUsers()" [stacked]="true" margin-left-auto />
</div>
